(function () {
  'use strict';

  const SIZE_OPTION_NAMES = ['size', 'uk size', 'shoe size'];

  function initForceSizeSelection(container) {
    const radioGroups = container.querySelectorAll('input[type="radio"]');
    if (!radioGroups.length) return;

    let sizeInputs = [];
    radioGroups.forEach(input => {
      const name = (input.getAttribute('name') || '').toLowerCase();
      if (SIZE_OPTION_NAMES.some(s => name.includes(s))) {
        sizeInputs.push(input);
      }
    });

    if (!sizeInputs.length) return;

    sizeInputs.forEach(input => {
      input.checked = false;
    });

    const atcButton = container.querySelector('[type="submit"]:not([disabled])');
    if (!atcButton) return;

    atcButton.disabled = true;
    atcButton.setAttribute('data-force-size-disabled', 'true');

    let helperMsg = container.querySelector('.force-size-message');
    if (!helperMsg) {
      helperMsg = document.createElement('p');
      helperMsg.className = 'force-size-message';
      helperMsg.textContent = 'Please select a size to continue.';
      helperMsg.style.cssText = 'color: #c0392b; font-size: 0.875em; margin: 4px 0 0; display: block;';
      atcButton.parentNode.insertBefore(helperMsg, atcButton);
    }

    sizeInputs.forEach(input => {
      input.addEventListener('change', function () {
        if (atcButton.getAttribute('data-force-size-disabled') === 'true') {
          atcButton.disabled = false;
          atcButton.removeAttribute('data-force-size-disabled');
          helperMsg.style.display = 'none';
        }
      });
    });
  }

  function init() {
    const pdpContainers = document.querySelectorAll('.product-form, [data-section-type="main-product"], form[action="/cart/add"]');
    pdpContainers.forEach(container => initForceSizeSelection(container));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

})();
